import CollectionsPage from "./CollectionsPage"

export default CollectionsPage